import { render, staticRenderFns } from "./CreateCustomField.vue?vue&type=template&id=39c1ad9e&scoped=true&"
import script from "./CreateCustomField.vue?vue&type=script&lang=js&"
export * from "./CreateCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1ad9e",
  null
  
)

export default component.exports